import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-add-01',
	templateUrl: './icon-add-01.component.svg',
})
export class IconAdd01Component {}
